import React from 'react';

export const CompassSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28.991"
			height="28.991"
			viewBox="0 0 28.991 28.991">
			<g data-name="compass_tab" transform="translate(1509.596 -797.155)">
				<path
					data-name="compass_path1"
					d="M13.836,2A11.836,11.836,0,0,1,22.2,22.2,11.836,11.836,0,1,1,5.467,5.467,11.758,11.758,0,0,1,13.836,2Zm0,21.671A9.836,9.836,0,1,0,4,13.836,9.847,9.847,0,0,0,13.836,23.671Z"
					transform="matrix(0.259, -0.966, 0.966, 0.259, -1512.045, 821.434)"
				/>
				<path
					data-name="compass_path1"
					d="M8.876,11.254h0L3.444,7.668,8.487,4.786l.388,6.465ZM2.768,6.5v0L2.378,0,7.837,3.6,2.77,6.5Z"
					transform="translate(-1500.727 806.024)"
				/>
			</g>
		</svg>
	);
};

export const MapSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="22.396"
			height="18.455"
			viewBox="0 0 22.396 18.455">
			<g data-name="map_tab" transform="translate(1474.254 -868.914)">
				<path
					data-name="map_path1"
					d="M1.285-1.65,6.44-2.885a.428.428,0,0,1,.428.428V13.819a.428.428,0,0,1-.428.428L1.285,15.483A1.285,1.285,0,0,1,0,14.2V-.365C0-1.074.366-1.349,1.285-1.65Z"
					transform="translate(-1474.254 871.885)"
				/>
				<path
					data-name="map_path2"
					d="M5.583,14.247.428,15.483A.428.428,0,0,1,0,15.055V-1.221A.428.428,0,0,1,.428-1.65L5.583-2.885A1.285,1.285,0,0,1,6.868-1.6V12.962C6.868,13.672,6.5,13.947,5.583,14.247Z"
					transform="translate(-1458.726 871.799)"
				/>
				<path
					data-name="map_path3"
					d="M.428,0l5.9,1.2a.428.428,0,0,1,.428.428V17.9a.428.428,0,0,1-.428.428l-5.9-1.2A.428.428,0,0,1,0,16.7V.428A.428.428,0,0,1,.428,0Z"
					transform="translate(-1466.435 868.951)"
				/>
			</g>
		</svg>
	);
};

export const CollectionsSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24.673"
			height="22.516"
			viewBox="0 0 24.673 22.516">
			<path
				data-name="collection_path1"
				d="M.644,9.1l5.033,2.925,5.937,3.622h0a1.3,1.3,0,0,0,1.344,0l4.4-2.666,6.665-3.845a1.294,1.294,0,0,0,0-2.24L17.24,2.953,13.012.208a1.294,1.294,0,0,0-1.406,0L6.714,3.362.647,6.861a1.294,1.294,0,0,0,0,2.24"
				transform="translate(0 0)"
			/>
			<path
				data-name="collection_path2"
				d="M.646,42.01l5.038,2.917,5.942,3.612h0a1.294,1.294,0,0,0,1.344,0l4.4-2.673,6.659-3.856A1.275,1.275,0,0,0,24.668,41a1.291,1.291,0,0,0-.453-1.1L17.9,43.56l-4.389,2.668a2.329,2.329,0,0,1-2.42,0L5.156,42.621.458,39.9A1.292,1.292,0,0,0,.005,41,1.277,1.277,0,0,0,.646,42.01"
				transform="translate(0 -29.576)"
			/>
			<path
				data-name="collection_path3"
				d="M24.216,52.9,17.9,56.56l-4.389,2.668a2.329,2.329,0,0,1-2.42,0L5.156,55.621.458,52.9A1.291,1.291,0,0,0,.005,54,1.277,1.277,0,0,0,.646,55.01l5.038,2.917,5.942,3.612h0a1.294,1.294,0,0,0,1.344,0l4.4-2.673,6.659-3.856A1.276,1.276,0,0,0,24.668,54a1.291,1.291,0,0,0-.453-1.1"
				transform="translate(0 -39.211)"
			/>
		</svg>
	);
};

export const BookmarksSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="13.708"
			height="18.278"
			viewBox="0 0 13.708 18.278">
			<path
				data-name="bookmarks_tab"
				d="M0,18.278V1.714A1.714,1.714,0,0,1,1.714,0H11.995a1.714,1.714,0,0,1,1.714,1.714V18.278l-6.854-4Z"
			/>
		</svg>
	);
};
